import { useDomSize } from "~/hook/base/useDomSize.ts";
import { useGeolocation } from "~/hook/base/useGeolocation.ts";
import { usePoke } from "~/hook/domain/usePoke.ts";

export const usePokeWithGeolocation = (email: string, close: () => void) => {
  const {
    domRef,
    size: { height, width },
  } = useDomSize<HTMLDivElement>();
  const { isMutating, trigger } = usePoke();
  const { data, isLoading } = useGeolocation();

  const handleSend = () => {
    if (data) {
      void trigger({
        email,
        payload: {
          position: {
            latitude: data.coords.latitude,
            longitude: data.coords.longitude,
          },
          type: "geolocation",
        },
      }).then(close);
    }
  };

  return {
    disabled: isMutating || isLoading,
    domRef,
    handleSend,
    height,
    width,
  };
};
